module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Medium-ef677e217f2009c1685499df33414127.ttf";